export default {"src":"/_next/static/image/src/images/Icons/arrow-left.ecd624999113a781aa573bfd1ace7762.svg","height":16,"width":22};